import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthUser, Role } from '../../shared/models/user.model';
import { UsersService } from '../../shared/services/users.service';

@Component({
  standalone: false,
  selector: 'app-balance-widget',
  templateUrl: 'balance-widget.component.html',
  styleUrls: ['balance-widget.component.scss'],
})
export class BalanceWidgetComponent implements OnInit {
  currentValue = 0;
  user: AuthUser;
  isBillingAvailableForUser = false;

  constructor(
    public service: UsersService,
    private router: Router
  ) {}

  ngOnInit() {
    this.service.balanceUpdates.subscribe(balance => {
      this.currentValue = balance;
      this.service.getAuthUser().then(user => {
        this.user = user;
      });
    });
    this.service.isBillingAvailableForUser().subscribe({
      next: res => {
        this.isBillingAvailableForUser = res;
      },
      error: e => {
        console.error('Error checking billing availability for user', e);
      },
    });
  }

  onBalanceWidgetClick(): void {
    if (!this.isBillingAvailableForUser) return;
    if (this.user?.role === Role.SUB) return;
    if (this.user?.paymentType === 'PREPAID' || this.user?.role === Role.ADMIN) {
      this.router.navigate(['/billing/prepaid']);
    }
  }
}
